import { StyledText } from '@repo/ui/atoms';
import { Fragment } from 'react';

type Props = { text: string; align?: 'left' | 'center' | 'right' };

const MultilineText = ({ text, align }: Props) => {
    return (
        <>
            {text?.split('\n\n').map(v => (
                <StyledText variant="body" key={v} align={align} weight="regular">
                    {v.split('\n').map(k => (
                        <Fragment key={k + v}>
                            {k} <br />
                        </Fragment>
                    ))}
                </StyledText>
            ))}
        </>
    );
};

export default MultilineText;
